<div class="outer-content">
  <div class="container" style="display: flex;justify-content: center;">
  <div class="float-left bg-white card-background-editview margin-left">
    <form [formGroup]="userForm" autocomplete="off" role="form" class="fieldHeight">
      <app-content-top-nav [visibleBackNav]='true' [enableBackNav]='true' (onBackClickHandler)="OnBackClick()"></app-content-top-nav>
      <div class="col-md-12 clear-all title-wrapper">
        <h1 id="quote-playback-header" class="title-text custom-header-h2 responsive-text-8">{{contentData.header}}</h1>
      </div>
      <div class="col-md-12 clear-all content-wrapper custom-margin">
        <p id="quote-playback-introduction" class="intro-font margin-top-0">{{contentData.introduction}}</p>
      </div>
      <ng-container *ngFor="let list of playbackList">
        <ng-container *ngIf="getVisibility(list)">
          <app-edit-details [productCode]="selectedProductCode" [isEdit]="list.edit" [parent]="userForm" [title]="list.title" 
          [storeName]="list.storeName" [onClickGoTo]="list.onEditNavigation" (click)="click()"
          [dataList]="list.control" [ftrpDataList]="list.ftrpControl" [corpDataList]="list.corpControl"
          [referenceNumber]="referenceNumber"></app-edit-details>
        </ng-container>
      </ng-container>
  
      <div class="col-md-12 underline margin-top-30"></div>
      <div class="question-wrapper">
        <app-question (riskTaxEmitter)="riskTaxReceiver($event)" [childId]="'taxPayRisk'" [questionConfig]="contentData.taxPayRiskQuestion" [parent]="riskQuestionForm" 
                       [controlName]="'taxPayRisk'" (onDisplayMobileTooltipEmitter)="displayTooltipMessage(contentData.taxPayRiskQuestion)">
        </app-question>
        <app-question (riskOverallReturnEmitter)="riskOverallReturnFTRPReceiver($event)" [childId]="'overAllReturnRisk'" [questionConfig]="contentData.overAllReturnRiskQuestion" [parent]="riskQuestionForm" [controlName]="'overAllReturnRisk'" 
                      (onDisplayMobileTooltipEmitter)="displayTooltipMessage(contentData.overAllReturnRiskQuestion)" *ngIf="selectedProductCode === 'H'"> 
        </app-question>
        <app-question (riskOverallReturnEmitter)="riskOverallReturnCORPReceiver($event)" [childId]="'overAllReturnRisk'" [questionConfig]="contentData.overAllReturnRiskQuestion" [parent]="riskQuestionForm" [controlName]="'overAllReturnRisk'" 
                      (onDisplayMobileTooltipEmitter)="displayTooltipMessage(contentData.overAllReturnRiskQuestion)" *ngIf="selectedProductCode === 'G'"> 
        </app-question>
        <app-question (riskInflationEmitter)="riskInflationReceiver($event)" [childId]="'inflation'" [questionConfig]="contentData.inflationRiskQuestion" [parent]="riskQuestionForm"
                       [controlName]="'inflation'" (onDisplayMobileTooltipEmitter)="displayTooltipMessage(contentData.inflationRiskQuestion)">
        </app-question>
        <app-question (riskLongTermCareEmitter)="riskLongTermCareReceiver($event)" [childId]="'claimPensionRisk'" [questionConfig]="contentData.claimPensionRiskQuestion" 
                      [parent]="riskQuestionForm" [controlName]="'claimPensionRisk'" (onDisplayMobileTooltipEmitter)="displayTooltipMessage(contentData.claimPensionRiskQuestion)">
        </app-question>
        <app-question (riskDebtMgmtEmitter)="riskDebtMgmtReceiver($event)" [childId]="'takeOutPensionRisk'" [questionConfig]="contentData.takeOutPensionRiskQuestion" 
                      [parent]="riskQuestionForm" [controlName]="'takeOutPensionRisk'" (onDisplayMobileTooltipEmitter)="displayTooltipMessage(contentData.takeOutPensionRiskQuestion)">
        </app-question>
        <app-question (consentEmitter)="consentReceiver($event)" [childId]="'consent'" [questionConfig]="contentData.consentQuestion" [parent]="userForm" [controlName]="'consent'" 
                      (onDisplayMobileTooltipEmitter)="displayTooltipMessage(contentData.consentQuestion)" *ngIf="selectedProductCode === 'C'">
        </app-question>
        <!-- <app-question [childId]="'amserror'" [questionConfig]="contentData.amsErrorQuestion" [parent]="userForm" [controlName]="'amserror'" *ngIf="amsErrorFlag">
        </app-question> -->

        <app-modal *ngIf="displayTooltipAlert" [modalConfig]="tooltipModalConfig" (closeModal)="closeModal()"
        (primaryBtnClick)="alertTooltipPrimaryBtnClick()" (secondaryBtnClick)="alertSecondaryBtnClick()" [tooltipFlag]="true"></app-modal>
        
      </div>
      <div class="question-wrapper padding-40">
        <div class="clear-both form-validation-error" *ngIf="amsErrorFlag">
          <i class="icon icon-error" aria-hidden="true"></i>
          <p [id]="'ams-error'" aria-hidden="false" role="error">
            {{contentData.amsErrorQuestion}}
          </p>
        </div>
      </div>
      
      <app-content-bottom-nav *ngIf="!getQuoteFlag" [disabled]="false" (onNextHandler)="gotoNextPage()" [userInputDetail]="userInputDetail['buttonConfig']"
        [buttonType]="'chevronCTA'"></app-content-bottom-nav>
  
        <div *ngIf="getQuoteFlag" class="col-md-12">
          <button class="btn btn-cta btn-loading float-right mar-zindex" type="button">
            <span class="btn-text">CTA button</span>
            <div class="spinner spinner-white">
              <div class="spinner-ring" aria-hidden="true"></div>
              <span class="access">Loading...</span>
            </div>
          </button>
        </div>
  
    </form>
  </div>
  </div>
</div>
  <app-modal *ngIf="displayAlert" [modalConfig]="alertLoginModalConfig" (closeModal)="closeModal()" (primaryBtnClick)="alertPrimaryBtnClick()"
        (secondaryBtnClick)="alertSecondaryBtnClick()" [saveDataFlag]="saveAlertWithoutLogin"></app-modal>
        <app-modal *ngIf="isLocked" [modalConfig]="lockedAlertModalConfig" (closeModal)="closeLockedModal()"
        (primaryBtnClick)="closeLockedModal()" [saveDataFlag]="false">
  </app-modal> <app-modal *ngIf="displayACEFlag && !noWarningMSg" [modalConfig]="aceAlertModal" (closeModal)="closeErrorModal()"
  (primaryBtnClick)="alertErrorPrimaryBtnClick()" (dontShowUpMsgAgain)="dontShowUPMsgAgain($event)" [saveDataFlag]="false">
  